"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "ALL_LOCATION_HEADERS", {
  enumerable: true,
  get: function () {
    return _providerComponents.ALL_LOCATION_HEADERS;
  }
});
_Object$defineProperty(exports, "DEFAULTS", {
  enumerable: true,
  get: function () {
    return _providerComponents.DEFAULTS;
  }
});
_Object$defineProperty(exports, "LOGGING", {
  enumerable: true,
  get: function () {
    return _providerComponents.LOGGING;
  }
});
_Object$defineProperty(exports, "MAP_LOCATION_FIELDS", {
  enumerable: true,
  get: function () {
    return _providerComponents.MAP_LOCATION_FIELDS;
  }
});
_Object$defineProperty(exports, "MAX_AVAILABILITIES_TO_DISPLAY", {
  enumerable: true,
  get: function () {
    return _providerComponents.MAX_AVAILABILITIES_TO_DISPLAY;
  }
});
_Object$defineProperty(exports, "MAX_BADGE_FIELDS", {
  enumerable: true,
  get: function () {
    return _providerComponents.MAX_BADGE_FIELDS;
  }
});
_Object$defineProperty(exports, "PROVIDER_TYPES", {
  enumerable: true,
  get: function () {
    return _providerComponents.PROVIDER_TYPES;
  }
});
_Object$defineProperty(exports, "SLOTS_ERROR_STATUS", {
  enumerable: true,
  get: function () {
    return _providerComponents.SLOTS_ERROR_STATUS;
  }
});
_Object$defineProperty(exports, "SLOTS_LOADING_STATUS", {
  enumerable: true,
  get: function () {
    return _providerComponents.SLOTS_LOADING_STATUS;
  }
});
_Object$defineProperty(exports, "SLOTS_SUCCESS_STATUS", {
  enumerable: true,
  get: function () {
    return _providerComponents.SLOTS_SUCCESS_STATUS;
  }
});
_Object$defineProperty(exports, "VISIBILITIES", {
  enumerable: true,
  get: function () {
    return _providerComponents.VISIBILITIES;
  }
});
_Object$defineProperty(exports, "VISIT_TYPES", {
  enumerable: true,
  get: function () {
    return _providerComponents.VISIT_TYPES;
  }
});
var _providerComponents = require("@kyruus/provider-components");